module.exports = __webpack_public_path__ + "static/media/climb_mountain.4e42d141.jpg";